/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  BaseResponsePresignedUrlUploadResponse,
  BaseResponseString,
  GetDownloadPresignedUrlParams,
  GetUploadPresignedUrlParams,
} from './data-contracts';
import {HttpClient, RequestParams} from './http-client';

export class S3<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * @description S3 파일 업로드를 위한 Presigned URL을 생성합니다.
   *
   * @tags S3
   * @name GetUploadPresignedUrl
   * @summary Presigned URL 업로드 생성
   * @request GET:/app/s3/presigned-url/upload
   * @secure
   * @response `200` `BaseResponsePresignedUrlUploadResponse` Presigned URL 생성 성공
   * @response `400` `void` 잘못된 요청 (지원하지 않는 파일 타입)
   * @response `401` `void` 인증되지 않음
   * @response `403` `void` 리소스 접근 권한 없음
   * @response `404` `void` 존재하지 않는 리소스
   * @response `500` `void` 서버 내부 에러
   */

  getUploadPresignedUrlKey = (query: GetUploadPresignedUrlParams) => ['app', 's3', 'presigned-url', 'upload', query];

  getUploadPresignedUrl = async (query: GetUploadPresignedUrlParams, params: RequestParams = {}) => {
    const response = await this.http.request<BaseResponsePresignedUrlUploadResponse, void>({
      path: `/app/s3/presigned-url/upload`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

    return response;
  };

  /**
   * @description S3 파일 다운로드를 위한 Presigned URL을 생성합니다.
   *
   * @tags S3
   * @name GetDownloadPresignedUrl
   * @summary Presigned URL 다운로드 생성
   * @request GET:/app/s3/presigned-url/download
   * @secure
   * @response `200` `BaseResponseString` Presigned URL 생성 성공
   * @response `400` `void` 잘못된 요청 (지원하지 않는 파일 타입)
   * @response `401` `void` 인증되지 않음
   * @response `403` `void` 리소스 접근 권한 없음
   * @response `404` `void` 존재하지 않는 리소스
   * @response `500` `void` 서버 내부 에러
   */

  getDownloadPresignedUrlKey = (query: GetDownloadPresignedUrlParams) => [
    'app',
    's3',
    'presigned-url',
    'download',
    query,
  ];

  getDownloadPresignedUrl = async (query: GetDownloadPresignedUrlParams, params: RequestParams = {}) => {
    const response = await this.http.request<BaseResponseString, void>({
      path: `/app/s3/presigned-url/download`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

    return response;
  };
}
